<template>
  <!-- 文化活动 -->
  <!-- pc端 -->
  <div v-if="isPCFlag">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分-新闻列表 -->
    <div class="part_news_list containers">
      <div class="news_list">
        <div class="new_tag" v-for="(item,index) in tableData" :key="index" @click="details(item)">
          <!-- 背景大图 -->
          <div class="bg_new">
            <div class="bg_new_tag" :style="styleBg(item.coverUrl)"></div>
          </div>
          <!-- 新闻简介文字 -->
          <div class="new_main">
            <!-- 时间 -->
            <div class="new_time">发布时间：{{item.createTime}}</div>
            <!-- 新闻标题 -->
            <div class="new_title">{{item.title}}</div>
            <!-- 新闻内容简要 -->
            <div class="new_info">{{item.summary}}</div>
          </div>
        </div>
      </div>
      <!-- 页码 -->
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.size" background layout="pager" :total="18">
      </el-pagination>

    </div>
    <!-- 第五部分尾部公用组件 -->
    <bottomFooter></bottomFooter>
  </div>
  <!-- 移动端 -->
  <div v-else class="company-news-mobile">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>
    <!-- 第二部分-新闻列表 -->
    <div class="part_news_list_mobile mobile-container">
      <div class="news_list_mobile">
        <div class="new_tag_mobile" v-for="(item,index) in tableData" :key="index" @click="details(item)">
          <!-- 背景大图 -->
          <div class="bg_new_mobile">
            <div class="bg_new_tag bg_new_tag_mobile" :style="styleBg(item.coverUrl)"></div>
          </div>
          <!-- 新闻简介文字 -->
          <div class="new_main_mobile">
            <!-- 时间 -->
            <div class="new_time_mobile">发布时间：{{item.createTime}}</div>
            <!-- 新闻标题 -->
            <div class="new_title_mobile">{{item.title}}</div>
            <!-- 新闻内容简要 -->
            <div class="new_info_mobile">{{item.summary}}</div>
          </div>
        </div>
      </div>
      <!-- 页码 -->
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.size" background layout="pager" :total="18">
      </el-pagination>

    </div>
    <!-- 尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>
</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import bottomFooter from "@/components/global/bottomFooter.vue";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import animationUtils from "@/utils/animationUtils.js";
import API from "@/api/homeConfigManage.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "companyDynamic",
  data() {
    return {
      isPCFlag: true,
      //顶部导航数据
      topBgImg: require("../../assets/imgs/about/newstop_bg.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mbNews/newstop_bg.jpg"),
      bigTitle: {
        znTitle: "文化活动",
        enTitle: "CULTURE ACTIVITIES",
      },
      menuLi: {
        sortOne: {
          title: "关于我们",
          children: [
            {
              name: "产品中心",
              active: false,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: false,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: true,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: "文化活动",
          children: [
            {
              name: "新闻聚焦",
              active: false,
              url: "/companyNews",
            },
            {
              name: "文化活动",
              active: true,
              url: "/companyDynamic",
            },
          ],
        },
      },

      activeName: "动态",
      searchForm: {
        page: 1,
        size: 20,
      },
      pageTotal: 0,
      tableData: [],
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.getList();
  },
  methods: {
    styleBg(coverUrl) {
      if (coverUrl) {
        return {
          background: "url( " + coverUrl + ")" + "no-repeat",
          backgroundSize: "cover",
        };
      } else {
        return {
          background:
            "url(" + require("../../assets/imgs/about/newspic1.jpg") + ")",
          backgroundSize: "cover",
        };
      }
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    // 查询列表
    getList() {
      let data = Object.assign({}, this.searchForm);
      let stageObj = {
        新闻: "NEWS",
        动态: "DYNAMIC",
      };
      data.type = stageObj[this.activeName]; //NEWS('新闻'),DYNAMIC('动态')
      API.getWebList(data)
        .then((res) => {
          this.tableData = res.content.records;
          this.pageTotal = res.content.total;
          // 更新count
          // this.$emit("update", this.activeName, {
          //   totalCount: res.content.total,
          // });
        })
        .catch(() => {});
    },
    // 查看详情
    details(row) {
      this.$router.push({
        path: "/comNewsDetails",
        query: {
          type: "editDynamic",
          id: row.id,
        },
      });
    },
  },
  components: {
    topBigPic,
    mobileTopBigPic,
    bottomFooter,
    mobileBottomFooter,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-pagination {
  text-align: center;
}

::v-deep .el-pager li {
  width: 40px;
  height: 40px;
  font-size: 16px;
  padding: 0;
  line-height: 40px;
  text-align: center;
}

@media screen and (max-width: 936px) {
  .new_title {
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .new_info {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
}

@media screen and (min-width: 936px) and (max-width: 1260px) {
  .new_title {
    margin-bottom: 13px;
  }

  .new_info {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

@media screen and (min-width: 1260px) {
  .new_title {
    margin-bottom: 1.5vw;
  }
}

.bg_new_tag {
  width: 100%;
  transition: all 0.8s;
  height: 100%;
  /* background: url("../../assets/imgs/about/newspic1.jpg") no-repeat;
        background-size: 490px;
        background-size: cover; */
  transform: scale(1);
}
</style>
<style lang="scss" scoped>
.company-news-mobile {
  .part_news_list_mobile {
    padding: 164px 0 284px;
    .news_list_mobile {
      margin-bottom: 142px;
      .new_tag_mobile {
        min-height: 2329px;
        margin-top: 142px;
        cursor: pointer;
        .bg_new_mobile {
          width: 1778px;
          height: 1618px;
          .bg_new_tag_mobile {
          }
        }
        .new_main_mobile {
          width: 1778px;
          min-height: 711px;
          background: #ffffff;
          border: 4px solid #edefee;
          .new_time_mobile {
            font-size: 57px;
            color: #999999;
            margin-top: 105px;
          }
          .new_title_mobile {
            font-size: 71px;
            color: #000000;
            margin-top: 69px;
          }
          .new_info_mobile {
            font-size: 57px;
            color: #333333;
            line-height: 85px;
            margin-top: 135px;
          }
        }
      }
    }
  }
  ::v-deep .el-pager li {
    width: 142px;
    height: 142px;
    font-size: 57px;
    padding: 0;
    line-height: 142px;
    text-align: center;
  }
}
</style>